import {Component, OnInit} from '@angular/core';
import {User} from "../../user/user";
import * as fromStore from "../../store";
import {Store} from '@ngrx/store';
import {filter, switchMap} from 'rxjs/operators';
import {AuthService} from "../auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {UserSubscriptionIds} from "../../user/user-subscription";

@Component({
    selector: 'db-builder-signout',
    templateUrl: './builder-signout.component.html',
    styleUrls: ['./builder-signout.component.scss'],
    standalone: false
})
export class BuilderSignoutComponent implements OnInit{

  private user: User;
  private subscriptionId: any;
  public userSubscriptionIds: any = UserSubscriptionIds;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _store: Store<fromStore.DbStoreState>,
    private _authService: AuthService,
  ) {}

  ngOnInit() {
    const queryParams: any = (<any>this._route.queryParams).value;
    this.subscriptionId = parseInt(queryParams.subscr_id, 10);
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUser))
      )
      .subscribe((user: User) => {
        this.user = user;
      });
  }

  public signOut () {
    if (this._authService.canLogout() && this.user) {
      if (this.subscriptionId ) {
        this._authService.logout(`/checkout?subscr_id=${this.subscriptionId}`, this.user.id);
      }
      else {
        this._authService.logout('/sign-up?subscr_id=261', this.user.id);
      }
    }
  }

}
